import { StopPlaceTransitInfoDto, TransportMode, TripMode, StopPlaceType, TransitInfoDto, TransportSubmode } from '@/types/webapi';

export function getTransportModeIcon(value?: StopPlaceTransitInfoDto): string | undefined {
    const transportMode = value?.transportMode;

    switch (transportMode) {
        case TransportMode.Air:
            return 'mdi-airplane';
        case TransportMode.Bike:
            return 'kdi-bicycle';
        case TransportMode.Bus:
            return 'kdi-bus';
        case TransportMode.Water:
            return value?.stopPlaceType == StopPlaceType.CarFerryStation ? 'kdi-water' : 'kdi-speedboat';
        case TransportMode.Rail:
            return 'kdi-rail';
        case TransportMode.Metro:
            return 'kdi-rail';
        case TransportMode.Tram:
            return 'mdi-tram-side';
        case TransportMode.Coach:
            return 'kdi-bus';
        default:
            return undefined;
    }
}

export function getTransportModeIconColor(value?: TransportMode): string {
    switch (value) {
        case TransportMode.Water:
            return 'purple';
        case TransportMode.Rail:
            return 'blue-darken-1';
        default:
            return 'blue';
    }
}

export function getTripModeIcon(tripMode?: TripMode, transitInfo?: TransitInfoDto) {
    switch (tripMode) {
        case TripMode.Air:
            return 'mdi-airplane';
        case TripMode.Bicycle:
            return 'kdi-cycle';
        case TripMode.Bus:
            return 'kdi-bus';
        case TripMode.Cableway:
            return 'mdi-gondola';
        case TripMode.Water:
            return transitInfo
                ? transitInfo.transportSubmode == TransportSubmode.LocalCarFerry
                    ? 'kdi-water'
                    : 'kdi-speedboat'
                : 'kdi-speedboat';
        case TripMode.Funicular:
            return 'mdi-gondola';
        case TripMode.Lift:
            return 'mdi-gondola';
        case TripMode.Rail:
            return 'kdi-rail';
        case TripMode.Metro:
            return 'kdi-rail';
        case TripMode.Tram:
            return 'mdi-tram-side';
        case TripMode.Trolleybus:
            return 'kdi-bus';
        case TripMode.Monorail:
            return 'kdi-rail';
        case TripMode.Coach:
            return 'kdi-bus';
        case TripMode.Foot:
            return 'kdi-foot';
        case TripMode.Car:
            return 'mdi-car-side';
        case TripMode.Scooter:
            return 'mdi-scooter';
        default:
            return undefined;
    }
}

export function getTripModeIconBgColor(tripMode?: TripMode) {
    switch (tripMode) {
        case TripMode.Foot:
        case TripMode.Bicycle:
            return 'white';
        default:
            return 'grey-darken-5';
    }
}

export function getTripModeIconColor(tripMode?: TripMode) {
    switch (tripMode) {
        case TripMode.Foot:
        case TripMode.Bicycle:
            return 'white';
        case TripMode.Water:
            return 'purple';
        case TripMode.Rail:
            return 'blue-darken-1';
        default:
            return 'blue';
    }
}

export function useKolumbusIcons() {
    return {
        getTripModeIcon,
        getTripModeIconColor,
        getTransportModeIcon,
        getTransportModeIconColor
    };
}
